import { render, staticRenderFns } from "./profile-edit-tab.vue?vue&type=template&id=045caa9c&scoped=true"
import script from "./profile-edit-tab.vue?vue&type=script&lang=js"
export * from "./profile-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./profile-edit-tab.vue?vue&type=style&index=0&id=045caa9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045caa9c",
  null
  
)

export default component.exports